import ManagerGiftList from './ManagerGiftList.container';

export default ManagerGiftList;
